import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';

import { MspotService } from './application/services/mspot.service';
import { ApiMspotService } from './infrastructure/services/api-mspot.service';
import { MspotComponent } from './ui/components/mspot/mspot.component';

@NgModule({
    declarations: [MspotComponent],
    exports: [MspotComponent],
    imports: [CommonModule],
    providers: [
        ApiMspotService,
        MspotService,
    ],
})
// biome-ignore lint/complexity/noStaticOnlyClass: <explanation>
export class UiMspotModule {
    public static forRoot(): ModuleWithProviders<UiMspotModule> {
        return {
            ngModule: UiMspotModule,
            providers: [ MspotService ],
        };
    }
}
